export default abstract class Entity<T, TJSON, TParams> {
  protected constructor (_: TParams) {}
  abstract toJSON(): TJSON;
  abstract valueOf(): TJSON;
  abstract toString(): string;
  abstract isEqualTo(other: T | null | undefined): boolean;
}